export const positionStyle = [
  // {
  //   role: "wicketKeeper",
  //   style: "top-[210px] left-[530px]",
  //   top: 210,
  //   left: 530,
  // },
  {
    role: "",
    style: "top-[35px] left-[530px]",
    top: 35,
    left: 480,
  },
  {
    role: "",
    style: "top-[80px] left-[290px]",
    top: 70,
    left: 270,
  },
  {
    role: "",
    style: "top-[80px] left-[760px]",
    top: 80,
    left: 700,
  },
  {
    role: "",
    style: "top-[250px] left-[800px]",
    top: 250,
    left: 740,
  },
  {
    role: "",
    style: "top-[250px] left-[290px]",
    top: 250,
    left: 240,
  },
  {
    role: "",
    style: "top-[450px] left-[530px]",
    top: 400,
    left: 480,
  },
  {
    role: "",
    style: "top-[470px] left-[220px]",
    top: 470,
    left: 220,
  },
  {
    role: "",
    style: "top-[470px] left-[850px]",
    top: 450,
    left: 750,
  },
  {
    role: "",
    style: "top-[600px] left-[400px]",
    top: 600,
    left: 400,
  },
  {
    role: "",
    style: "top-[600px] left-[700px]",
    top: 600,
    left: 600,
  },
];
